<div class="attribution-toolbar">
  <ng-container *ngIf="userValidation$ | async as userValidation">
  <ng-container *ngIf="isOnActiveRoute('pattern')||isOnActiveRoute('editor')">

  <div class="button-wrapper" data-tour="step4">
    <button matTooltip="Nach Regelkreisphase gruppieren" [matTooltipShowDelay]="300"
      class="custom-button" [class.active]="isControlLoopActive" (click)="updateAttribution(attributionType.CONTROL_LOOP)">
      <img class="controlLoopIcon" src="../../../assets/files/regelkreis.png" alt="image" width="25px" height="25px" >
      <span class="button-text">Regelkreis</span>
    </button>
    <button matTooltip="Nach Frage gruppieren" [matTooltipShowDelay]="300"
      class="custom-button" [class.active]="isControlQuestionActive" (click)="updateSubAttribution(attributionType.CONTROL_QUESTION)">
      <mat-icon>question_mark</mat-icon>
      <span class="button-text">Leitfragen</span>
    </button>
  </div>

  </ng-container>
  </ng-container>
</div>
